// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionContainer_container__mGuRs"};